module.exports = __webpack_public_path__ + "img/138.64e22935.jpg";